import { __assign } from "tslib";
// Inspired by: https://github.com/wix-private/ecom/blob/e057721e6e654b324dc2c41f434e85b6307546fb/client/settings-editor-common-components/src/utils/fontUtils.ts#L51-L80
export function getFontFromPreset(presetName, textPresets) {
    if (textPresets === void 0) { textPresets = {}; }
    if (!textPresets[presetName]) {
        return null;
    }
    var preset = textPresets[presetName];
    return {
        size: parseInt(preset.size, 10),
        family: preset.fontFamily,
        preset: presetName,
        style: {
            bold: preset.weight === 'bold' || parseInt(preset.weight, 10) >= 700,
            italic: preset.style === 'italic',
            underline: false,
        },
        fontStyleParam: false,
        weight: preset.weight,
        // Since the `value` field is being generated dynamically, but wix font options is generated by user, we will just omit it.
        // After, a withStyles HOC will generate the correct value.
    };
}
export function getWixFont(_a) {
    var name = _a.name, textPresets = _a.textPresets;
    return getFontFromPreset(name, textPresets);
}
export var wixFontParam = function (name, options) {
    if (options === void 0) { options = {}; }
    return function (_a) {
        var textPresets = _a.textPresets;
        var optionsWithWeight = addWeightToOptions(options);
        return __assign(__assign({}, getWixFont({ name: name, textPresets: textPresets })), optionsWithWeight);
    };
};
function addWeightToOptions(options) {
    if (options.style && 'bold' in options.style) {
        options.weight = options.style.bold ? 'bold' : 'normal';
    }
    return options;
}
//# sourceMappingURL=getWixFont.js.map